var render, staticRenderFns
import script from "./GroupHeaderDetail.vue?vue&type=script&lang=js&"
export * from "./GroupHeaderDetail.vue?vue&type=script&lang=js&"
import style0 from "./GroupHeaderDetail.vue?vue&type=style&index=0&id=3e0ee9da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0ee9da",
  null
  
)

export default component.exports